<template>
  <el-table-column
    label="Bolt látogatások"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.all_routes.length" :type="getStatus(scope.row.all_routes).tag" size="small">
        <i class="el-icon-circle-check"></i> {{ getStatus(scope.row.all_routes).done }} / {{ scope.row.all_routes.length }}
      </el-tag>
      <el-tag v-else type="warning" size="small">Nincesnek boltok</el-tag>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'status',
    methods: {
      getStatus(routes) {
        let done = 0;
        let inProgress = 0;
        let todo = 0;
        let failed = 0;
        let tag = '';
        routes.forEach(route => {
          switch(route.status) {
            case 'done':
              done++;
              break;
            case 'in-progress':
              inProgress++;
              break;
            case 'todo':
              todo++;
              break;
            case 'failed':
              failed++;
              break;
          }
        });
        if (done === routes.length) {
          tag = 'success';
        } else if (inProgress > 0 || todo && todo < routes.length) {
          tag = 'warning';
        } else if(todo === routes.length) {
          tag = 'info';
        } else {
          tag = 'danger'
        }
        return {
          tag: tag,
          done: done
        };
      }
    }
  };
</script>
